import { Pipe, PipeTransform } from '@angular/core';

import capitalize from 'capitalize';

@Pipe({
    name: 'formatEnum',
    standalone: false
})
export class FormatEnumPipe implements PipeTransform {
	transform(value: string): string {
		if (value) {
			return capitalize.words(value.replace(/_/g, ' '));
		}
		return '';
	}
}
